<template>
  <div class="selector">
    <div class="selector-headers">
      <li :class="{
        'selector-selected-item':selected.header===item
      }" v-for="(item, index) in headers" :key="index" class="selector-header-item" @click="onHeaderClick(item)">
        {{item}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li :class="{
        'selector-selected-item':selected.item.text===item.text
      }" v-for="(item, index) in items" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.text}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li :class="{
        'selector-selected-item':selected.item.text===item.text
      }" v-for="(item, index) in all" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.text}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="select-form">
      <div  class="form-horizontal">
        <brand-form :brand="brand"></brand-form>
        <div class="form-group">
          <div class="col-sm-10 col-sm-offset-2">
            <button class="btn btn-default" @click="addBrand">添加</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as TYPES from '../../store/types'
import BrandForm from '@/components/forms/Brand'

export default {
  data() {
    return {
      brand: {},
      selected: {
        header: '',
        item: {}
      }
    }
  },
  components: {
    BrandForm
  },
  computed: {
    headers() {
      return this.$store.state.brands.selector.headers
    },
    items() {
      return this.$store.state.brands.selector.items
    },
    all() {
      return this.$store.state.brands.all
    }
  },
  created() {
    this.$store.dispatch(TYPES.DO_GET_BRANDS_SELECTOR_HEADERS)
    this.$store.dispatch(TYPES.DO_GET_ALL_BRANDS)
  },
  methods: {
    onHeaderClick(item) {
      this.$store
        .dispatch(TYPES.DO_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER, item)
        .then(res => {
          this.selected.header = item
        })
        .catch(res => {
          console.log(res)
        })
    },
    onSelected(item) {
      this.$emit('onSelected', item)
    },
    addBrand() {
      this.$store.dispatch(TYPES.DO_ADD_BRAND, this.brand)
      .then(res => {
        this.$notify({
          type: 'success',
          content: '成功添加品牌！'
        })
        this.onHeaderClick(this.selected.header)
      })
      .catch(res => {
        console.log(res)
        this.$notify({
          type: 'danger',
          content: res.data.msg
        })
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/selectors/Brand.vue